<template>
  <div>
    <form method="post">
      <input type="hidden" name="authenticity_token" :value="token">
      <div class="w-64 ml-auto">
        <label class="sr-only">Email address</label>
        <input v-model="filterInput" class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm" placeholder="Search by name or email">
      </div>
      <table class="mt-2 min-w-full divide-y divide-gray-200">
        <thead>
        <tr>
          <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
          Assigned
          </th>
          <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
            Referrers
          </th>
          <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
            Referees
          </th>
          <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
            Earnings to date
          </th>
          <th class="px-6 py-3 bg-gray-50"></th>
        </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200" v-if="filteredReferees.length > 0 || filteredAvailableUsers.length > 0" >
        <tr v-for="r in filteredReferees">
          <td class="px-6 py-4 whitespace-no-wrap">
            <div class="relative flex items-start">
              <div class="flex items-center h-5">
                <input id="" :value="r.id" name="selected[]" type="checkbox" checked="true"
                       class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded">
              </div>
            </div>
          </td>
          <td class="px-6 py-4 whitespace-no-wrap">
            <div class="flex items-center">
              <div class="ml-4">
                <div class="text-sm leading-5 font-medium text-gray-900">
                  <a class="underline">
                    {{ r.profile.name }}
                  </a>
                </div>
                <div class="text-sm leading-5 text-gray-500">
                  {{ r.email }}
                </div>
              </div>
            </div>
          </td>
          <td class="px-6 py-4 whitespace-no-wrap">
            <div class="text-sm leading-5 text-gray-900">
              {{ r.profile.country.name }}
            </div>
          </td>
          <td class="px-6 py-4 whitespace-no-wrap">
            <div class="text-sm leading-5 text-gray-900">
              {{ formatDate(r.created_at) }}
            </div>
          </td>
        </tr>
        <tr v-for="r in filteredAvailableUsers">
          <td class="px-6 py-4 whitespace-no-wrap">
            <div class="relative flex items-start">
              <div class="flex items-center h-5">
                <input name="selected[]" type="checkbox" :value="r.id"
                       class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded">
              </div>
            </div>
          </td>
          <td class="px-6 py-4 whitespace-no-wrap">
            <div class="flex items-center">
              <div class="ml-4">
                <div class="text-sm leading-5 font-medium text-gray-900">
                  <a class="underline">
                    {{ r.profile.name }}
                  </a>
                </div>
                <div class="text-sm leading-5 text-gray-500">
                  {{ r.email }}
                </div>
              </div>
            </div>
          </td>
          <td class="px-6 py-4 whitespace-no-wrap">
            <div class="text-sm leading-5 text-gray-900">
              {{ r.profile.country.name }}
            </div>
          </td>
          <td class="px-6 py-4 whitespace-no-wrap">
            <div class="text-sm leading-5 text-gray-900">
              {{ formatDate(r.created_at) }}
            </div>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5" class="text-center pt-4 text-gray-700">
            No users found
            </td>
          </tr>
        </tbody>
      </table>
    </form>
      <button @click="filterInput = '';" type="submit" class="btn btn-primary mt-5">
        Update referrers
      </button>
  </div>
</template>

<script>
export default {
  name: "referees-table",
  props: ["referees", "availableUsers"],
  data: function(){
    return {
      token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      filterInput: ""
    }
  },
  computed: {
    filteredReferees: function(){
      return this.referees.filter(x => {
        return x.email.match(this.filterInput) || x.profile.name.match(this.filterInput);
      })
    },
    filteredAvailableUsers: function(){
      return this.availableUsers.filter(x => {
        return x.email.match(this.filterInput) || x.profile.name.match(this.filterInput);
      })
    }
  },
  methods: {
    formatDate(date){
      const formattedDate = new Date(date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });
      return formattedDate;
    }
  }
}
</script>

<style scoped>

</style>